// src/Donation.js
import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';

const Donation = () => {
  const [donationAmount, setDonationAmount] = useState(35);

  const handleInputChange = (event) => {
    const value = event.target.value;
    setDonationAmount(value);
  };

  const handleButtonClick = (amount) => {
    setDonationAmount(amount);
  };

  const finalSubmit =()=>{
    var options = {
      key: "rzp_test_xxxBYaLwXFq6nL",
      key_secret: "tQduw7TF6KShUloM4R2UKZmZ",
      amount: parseInt(donationAmount) * 100,
      currency: "INR",
      name: "Kusavini Balaga",
      description: `Donation Payment succesfull`,
      handler: async function (response) {
        const paymentId = response.razorpay_payment_id;
        console.log("paymant id", paymentId);

        Swal.fire({
          icon: 'success',
          title: 'Donation Successful',
          text:`Successful donated ₹${donationAmount}`,
          confirmButtonText: 'OK'
      });
      },
      theme: {
        color: "#07a291db",
      },
    };
    var pay = new window.Razorpay(options);
    pay.open();
  }

  return (
    <Container className="mt-5">
      <Card className="shadow-lg border-0">
        <Card.Body>
          <h2 className="text-center mb-4">Make a One-Time Donation</h2>
          <p className="text-center text-muted">A quality education changes lives. And it starts with you.</p>
          <Form>
            <Row className="justify-content-center mb-3">
              <Col md={6} xs={12}>
                <Form.Group controlId="donationAmount">
                  <Form.Label className="fw-bold">I'm giving</Form.Label>
                  <Form.Control
                    type="number"
                    value={donationAmount}
                    onChange={handleInputChange}
                    placeholder="Enter donation amount"
                    className="shadow-sm"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="justify-content-center mb-3">
              <Col md={8} xs={12}>
                <div className="d-flex justify-content-center">
                  <Button variant="outline-secondary" onClick={() => handleButtonClick(1000)} className="me-2">
                  ₹1000
                  </Button>
                  <Button variant="outline-secondary" onClick={() => handleButtonClick(5000)} className="me-2">
                  ₹5000
                  </Button>
                  <Button variant="outline-secondary" onClick={() => handleButtonClick(10000)} className="me-2">
                  ₹10000
                  </Button>
                  <Button variant="outline-secondary" onClick={() => handleButtonClick('')}>
                    OTHER
                  </Button>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center mb-3">
              <Col md={8} xs={12}>
                <div className="d-flex justify-content-center">
                  {/* <Button variant="primary" className="me-2">GIVE BY CARD</Button> */}
                  <Button variant="primary" onClick={finalSubmit}>Pay</Button>
                </div>
              </Col>
            </Row>
            {/* <p className="text-center mt-4 text-muted">Other Ways You Can Give</p> */}
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Donation;
